import React from 'react';
import { Link } from 'react-router-dom';
import img from '../images/kitchen.png'; 
import img2 from '../images/bathroom.jpeg';
import img3 from '../images/floor.jpeg';
import img4 from '../images/founder.png';

const Services = () => {

    return (
        <div id="services" className="bg-white-100 py-12" >
            <section data-aos="zoom-in-down">
                    <div className="my-0 py-0">
                        <h2 className="my-2 text-center text-4xl text-red-900 uppercase font-bold">services</h2>
                        
                        <div className='flex justify-center'>
                            <div className='w-20 border-b-4 border-red-900'></div>
                        </div>
                        <h3 className="mt-4 mx-12 text-center text-xl lg:text-3xl font-semibold text-red-900">Personalized Cleaning for Every Home.</h3>
                        <p className="text-md text-center text-xl lg:text-2xl font-medium">From sparkling kitchens to pristine bathrooms, we've got you covered every clean, every time.</p>
                      
                    </div>

                    <div className="px-12" data-aos="fade-down" data-aos-delay="600">
                        <div className="grid sm:grid-cols-3 lg:grid-cols-3 gap-5">
                            
                            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-red-800 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-5 text-justify text-sm">
                                <img alt="card img" className="rounded-t group-hover:scale-[1.1] transition duration-1000 ease-in-out" src={img} />
                                    <h2 className="font-semibold my-4 text-2xl text-center">Kitchen Deep Cleaning</h2>
                                    <p className="text-md font-medium">
                                        A thorough clean that tackles built-up grease and grime, including detailed oven, refrigerator, and cabinet cleaning for a fresh, hygienic kitchen.
                                    </p>
                                </div>
                                <div className="flex justify-right my-4 hover:font-semibold ">
                                    <Link to="/contact" className=" inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                                        Get Started
                                        <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    </Link>
                                </div>                                
                            </div>

                            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-gray-600 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-5 text-justify text-sm">
                                <img alt="card img" className="rounded-t group-hover:scale-[1.1] transition duration-1000 ease-in-out" src={img2} />
                                    <h2 className="font-semibold my-4 text-2xl text-center">Bathroom Sanitization</h2>
                                    <p className="text-md font-medium">
                                        We thoroughly disinfect and deep clean sinks, toilets, showers, tubs, and surfaces to leave your bathroom fresh, clean, and sanitary.

                                    </p>
                                    <div className="flex justify-right my-4 hover:font-semibold">
                                        <Link to="/contact" className=" inline-flex over:text-gray-900 items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                                            Get Started
                                            <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                        </Link>
                                    </div>
                                </div>
                                    
                            </div>

                            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-red-800 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-5 text-justify text-sm">
                                    <img alt="card img" className="rounded-t group-hover:scale-[1.1] transition duration-1000 ease-in-out" src={img3} />
                                    <h2 className="font-semibold my-4 text-2xl text-center ">Floor + Carpet Cleaning</h2>
                                    <p className="text-md font-medium">
                                        We deep clean all floor surfaces, vacuum thoroughly, and provide attentive carpet care to keep your home looking fresh and well-maintained.
                                    </p>
                                </div>
                                <div className="flex justify-right my-4 hover:font-semibold ">
                                    <Link to="/contact" className=" inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                                        Get Started
                                        <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    </Link>
                                </div>                                 
                            </div>
                        </div>
                    </div>
            </section>

            <section>
                <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="zoom-out">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                           <img alt="card img" className=" w-100 rounded-t transition duration-1000 ease-in-out" src={img4} />
                        </div>
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                           <h3 className="text-2xl  text-red-900 font-bold">Meet our founder, <span className='font-black'>Kim Ordoñez</span></h3>
                            <div>
                                <p className='my-3 text-xl text-gray-700 font-semibold'>Founded on passion and precision, <span className='font-black'>KIM MAIDS CLEANING SERVICES</span> is led by Kim Ordoñez, who brings over 10 years of professional cleaning expertise. Her unwavering commitment to excellence and meticulous attention to detail ensure top-tier care for every home.</p>
                            </div>
                            <div>
                                <p className='my-3 text-xl text-gray-500 font-semibold '>"Whatever you do, work heartily, as for the Lord and not for men, knowing that from the Lord you will receive the inheritance as your reward. You are serving the Lord Christ." Colossians 3:23-24 - ESV</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services;